var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescription = function SvgDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "description_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 18h8v-2H8zm0-4h8v-2H8zm-4 8V2h10l6 6v14zm9-13V4H6v16h12V9zM6 4v5zv16z"
  })));
};
export { SvgDescription as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNOCAxOEgxNlYxNkg4VjE4Wk04IDE0SDE2VjEySDhWMTRaTTQgMjJWMkgxNEwyMCA4VjIySDRaTTEzIDlWNEg2VjIwSDE4VjlIMTNaTTYgNFY5VjRWOVYyMFY0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";